import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { Box, Chip } from '@mui/material';
import {
  Folder as FolderIcon,
  InsertDriveFile as FileIcon,
} from '@mui/icons-material';
import { getFileIcon } from '../../../utils/getFileIcon';
import { getFolderName } from '../../../utils/getFolderName';

export function FileDragOverlay({ activeItem }) {
  if (!activeItem) return <DragOverlay />;

  const { type, item } = activeItem;
  const isFolder = type === 'folder';

  const label = isFolder
    ? getFolderName(item.folder_name)
    : item.filename;

  const icon = isFolder
    ? <FolderIcon fontSize="small" />
    : (item.filetype ? getFileIcon(item.filetype, 'small') : <FileIcon fontSize="small" />);

  return (
    <DragOverlay dropAnimation={null}>
      <Box sx={{ cursor: 'grabbing' }}>
        <Chip
          icon={icon}
          label={label}
          size="small"
          color={isFolder ? 'secondary' : 'primary'}
          sx={{
            maxWidth: 220,
            opacity: 0.95,
            boxShadow: 4,
            fontWeight: 500,
            '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
          }}
        />
      </Box>
    </DragOverlay>
  );
}
